/**
 * Survives expo-router `router.replace` remounts: React state for the sign-in banner is lost
 * when the sign-in screen remounts; stash text here first, then consume on sign-in mount.
 */

let pendingSignInBannerMessage: string | null = null

export function setPendingSignInBannerMessage(message: string): void {
  pendingSignInBannerMessage = message
}

/** Returns the pending message once and clears it. */
export function consumePendingSignInBannerMessage(): string | null {
  const msg = pendingSignInBannerMessage
  pendingSignInBannerMessage = null
  return msg
}
